import React from 'react'

const WarehouseIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 64 64"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#d9d9d9"
                        d="M27.94 15.78A12 12 0 0 1 24 26a13.61 13.61 0 0 0-4 5.89c-.06.16.82.11-8 .11a14.33 14.33 0 0 0-4.1-6.14 12 12 0 1 1 20-10.08z"
                        opacity={1}
                        data-original="#d9d9d9"
                        className=""
                    />
                    <path
                        fill="#f3f3f3"
                        d="m15 35.29-4-13A1 1 0 0 1 12 21h8a1 1 0 0 1 1 1.29l-4 13a1 1 0 0 1-2 0zM13.35 23 16 31.6l2.65-8.6zM56 14v20H36V10a2 2 0 0 1 2-2h12z"
                        opacity={1}
                        data-original="#f3f3f3"
                        className=""
                    />
                    <path
                        fill="#ffac00"
                        d="M48 28.07v-2.14A1.92 1.92 0 0 0 46.07 24a1.92 1.92 0 0 1-1.81-1.31 13.47 13.47 0 0 0-.55-1.31 1.93 1.93 0 0 1 .36-2.21 1.94 1.94 0 0 0 0-2.73l-1.51-1.51a1.94 1.94 0 0 0-2.73 0 1.93 1.93 0 0 1-2.21.36 13.47 13.47 0 0 0-1.31-.55A1.92 1.92 0 0 1 35 12.93 1.94 1.94 0 0 0 33.07 11h-2.14A1.92 1.92 0 0 0 29 12.93a1.92 1.92 0 0 1-1.31 1.81 13.47 13.47 0 0 0-1.31.55 1.93 1.93 0 0 1-2.21-.36 1.94 1.94 0 0 0-2.73 0l-1.51 1.51a1.94 1.94 0 0 0 0 2.73 1.93 1.93 0 0 1 .36 2.21 13.47 13.47 0 0 0-.55 1.31A1.92 1.92 0 0 1 17.93 24 1.94 1.94 0 0 0 16 25.93v2.14A1.92 1.92 0 0 0 17.93 30a1.92 1.92 0 0 1 1.81 1.31 13.47 13.47 0 0 0 .55 1.31 1.93 1.93 0 0 1-.36 2.21 1.94 1.94 0 0 0 0 2.73l1.51 1.51a1.94 1.94 0 0 0 2.73 0 1.93 1.93 0 0 1 2.21-.36 13.47 13.47 0 0 0 1.31.55A1.92 1.92 0 0 1 29 41.07 1.94 1.94 0 0 0 30.93 43h2.14A1.92 1.92 0 0 0 35 41.07a1.92 1.92 0 0 1 1.31-1.81 13.47 13.47 0 0 0 1.31-.55 1.93 1.93 0 0 1 2.21.36 2 2 0 0 0 2.73 0l1.51-1.51a1.94 1.94 0 0 0 0-2.73 1.93 1.93 0 0 1-.36-2.21 13.47 13.47 0 0 0 .55-1.31A1.92 1.92 0 0 1 46.07 30 1.94 1.94 0 0 0 48 28.07z"
                        opacity={1}
                        data-original="#ffac00"
                        className=""
                    />
                    <circle
                        cx={32}
                        cy={27}
                        r={7}
                        fill="#f3f3f3"
                        opacity={1}
                        data-original="#f3f3f3"
                        className=""
                    />
                    <path
                        fill="#c5dcf1"
                        d="M6 30h26v34H8a2 2 0 0 1-2-2V30z"
                        opacity={1}
                        data-original="#93e6e5"
                        className="hovered-path"
                    />
                    <path
                        fill="#60a9eb"
                        d="M32 30h26v32a2 2 0 0 1-2 2H32V30zM6 30l-4.59 5.35A1 1 0 0 0 2.17 37h21.17a4 4 0 0 0 2.83-1.17L32 30z"
                        opacity={1}
                        data-original="#50d9d7"
                        className=""
                    />
                    <path
                        fill="#1975c9"
                        d="m58 30 4.59 5.35a1 1 0 0 1-.76 1.65H40.66a4 4 0 0 1-2.83-1.17L32 30z"
                        opacity={1}
                        data-original="#00bebd"
                        className=""
                    />
                    <rect
                        width={8}
                        height={4}
                        x={9}
                        y={57}
                        fill="#f3f3f3"
                        rx={1}
                        opacity={1}
                        data-original="#f3f3f3"
                        className=""
                    />
                    <circle
                        cx={37}
                        cy={59}
                        r={2}
                        fill="#f3f3f3"
                        opacity={1}
                        data-original="#f3f3f3"
                        className=""
                    />
                    <circle
                        cx={44}
                        cy={59}
                        r={2}
                        fill="#f3f3f3"
                        opacity={1}
                        data-original="#f3f3f3"
                        className=""
                    />
                    <path
                        fill="#d9d9d9"
                        d="M56 14h-4a2 2 0 0 1-2-2V8z"
                        opacity={1}
                        data-original="#d9d9d9"
                        className=""
                    />
                    <path
                        fill="#ffac00"
                        d="M59 28a1 1 0 0 1-.71-1.71l4-4a1 1 0 0 1 1.42 1.42l-4 4A1 1 0 0 1 59 28zM59 22a1 1 0 0 1-.71-1.71l2-2a1 1 0 0 1 1.42 1.42C59.53 21.89 59.54 22 59 22zM5 28a1 1 0 0 1-.71-.29l-4-4a1 1 0 0 1 1.42-1.42l4 4A1 1 0 0 1 5 28z"
                        opacity={1}
                        data-original="#ffac00"
                        className=""
                    />
                    <g fill="#50d9d7">
                        <circle
                            cx={59}
                            cy={10}
                            r={1}
                            fill="#60a9eb"
                            opacity={1}
                            data-original="#50d9d7"
                            className=""
                        />
                        <circle
                            cx={2}
                            cy={12}
                            r={1}
                            fill="#60a9eb"
                            opacity={1}
                            data-original="#50d9d7"
                            className=""
                        />
                        <circle
                            cx={13}
                            cy={1}
                            r={1}
                            fill="#60a9eb"
                            opacity={1}
                            data-original="#50d9d7"
                            className=""
                        />
                        <circle
                            cx={32}
                            cy={4}
                            r={1}
                            fill="#60a9eb"
                            opacity={1}
                            data-original="#50d9d7"
                            className=""
                        />
                        <circle
                            cx={46}
                            cy={4}
                            r={1}
                            fill="#60a9eb"
                            opacity={1}
                            data-original="#50d9d7"
                            className=""
                        />
                    </g>
                </g>
            </svg>
        </>
    )
}

export default WarehouseIcon